import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	FIN: {
		display: 'flex',
		gap: theme.spacing(1),
	},
}));

export const SurgeonEventFINInfo: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ children }) => {
	const classes = useStyles();
	return (
		<Box className={classes.FIN}>
			{children}
		</Box>
	);
};
